import { Grid, Typography } from '@material-ui/core';
import classNames from 'classnames';
import React, { FC } from 'react';

import Checkmark from '../images/checkmark-greenV2.svg';
import Info from '../images/info-blue.svg';
import WarningOrange from '../images/warning-orange.svg';
import WarningRed from '../images/warning-red.svg';
import useStyles from './styles';

export enum InlineMessageTypes {
  blue = 'blue',
  green = 'green',
  orange = 'orange',
  red = 'red',
}

export interface InlineMessageProps {
  message: React.ReactNode;
  className?: string;
  type: `${InlineMessageTypes}`;
  /**
   * The element the message renders as.
   *
   * `h4` is the element MUI derives from `variant="h4"` on its own, so the
   * default leaves every existing call site rendering exactly what it did. A
   * message that is a status, not a section title, passes `div`: an `<h4>`
   * puts it in the heading list a screen reader navigates by, beside the
   * headings that organize the page.
   */
  component?: React.ElementType;
}

export const InlineMessage: FC<InlineMessageProps> = ({ type, message, className, component = 'h4' }) => {
  const classes = useStyles();
  let icon;

  switch (type) {
    case 'red':
      icon = WarningRed;
      break;
    case 'orange':
      icon = WarningOrange;
      break;
    case 'blue':
      icon = Info;
      break;
    case 'green':
      icon = Checkmark;
      break;
    // no default
  }

  return (
    <Grid className={classNames(classes.root, classes[type], className)} container wrap="nowrap">
      <img alt="warning icon" className={classes.icon} src={icon} />
      <Typography component={component} variant="h4">
        {message}
      </Typography>
    </Grid>
  );
};
